<template>
  <DataTable
    :value="items"
    striped-rows
    :paginator="false"
	  scrollable
    class="custom-table"
  >
    <Column 
      field="creationDate" 
      :header="t('wkt.client.expensesheets.table.headers.creation_date')"
      sortable
      style="min-width: 120px"
    >
      <template #body="{ data }">
        {{ formatOnlyDate(data.creationDate) }}
      </template>
    </Column>

    <Column 
      field="name" 
      :header="t('wkt.client.expensesheets.table.headers.name')"
      sortable
      style="min-width: 200px"
    />

    <Column 
      field="amount" 
      :header="t('wkt.client.expensesheets.table.headers.amount')"
      sortable
      style="min-width: 120px"
    >
      <template #body="{ data }">
        {{ formatCurrency(data.amount) }}
      </template>
    </Column>

    <Column 
      field="projectName" 
      :header="t('wkt.client.expensesheets.table.headers.project')"
      sortable
      style="min-width: 150px"
    >
      <template #body="{ data }">
        {{ data.projectName || '-' }}
      </template>
    </Column>

    <Column 
      field="status" 
      :header="t('wkt.client.expensesheets.table.headers.status')"
      sortable
      style="min-width: 140px"
    >
      <template #body="{ data }">
        <Tag 
          :value="getStatusText(Number(data.status))"
          :severity="getStatusSeverity(Number(data.status))"
          :class="{ 'p-tag-forthcoming': Number(data.status) === -1 }"
        />
      </template>
    </Column>

    <Column style="width: 134px">
      <template #body="{ data }">
        <Button
          class="footer-primary-button"
          color="#185EA9"
          variant="text"
          size="small"
          @click="$emit('show-detail', data)"
          :label="t('wkt.client.expensesheets.table.show_detail').toUpperCase()"
        />
      </template>
    </Column>
  </DataTable>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useDateFormatter } from '@wkt/composables/useDateFormatter'
import { useExpenseSheets } from '@wkt/composables/useExpenseSheets'
import { useUtils } from '@wkt/composables/useUtils'
import type { ExpenseSheet } from '@wkt/api/expense-sheets'

// Props
interface Props {
  items: ExpenseSheet[]
}

defineProps<Props>()

// Emits
defineEmits<{
  'show-detail': [item: ExpenseSheet]
}>()

// Composables
const { t } = useI18n()
const { formatOnlyDate } = useDateFormatter()
const { getStatusText, getStatusSeverity } = useExpenseSheets()
const { formatCurrency } = useUtils()
</script>

<style scoped>


/*.expense-sheets-table :deep(.p-datatable-header) {
  background: var(--surface-50);
  border: 1px solid var(--surface-200);
}

.expense-sheets-table :deep(.p-datatable-thead > tr > th) {
  background: var(--surface-100);
  color: var(--text-color);
  font-weight: 600;
  border-color: var(--surface-200);
}

.expense-sheets-table :deep(.p-datatable-tbody > tr) {
  background: var(--surface-0);
}

.expense-sheets-table :deep(.p-datatable-tbody > tr:hover) {
  background: var(--surface-50);
}

.expense-sheets-table :deep(.p-datatable-striped .p-datatable-tbody > tr:nth-child(even)) {
  background: var(--surface-50);
}

.expense-sheets-table :deep(.p-datatable-striped .p-datatable-tbody > tr:nth-child(even):hover) {
  background: var(--surface-100);
}*/

</style>

